import React from "react";
import { Cookie, X } from "lucide-react";
import { businessDetails } from "../data/content";

export const CookieConsent = ({ open, onAccept, onReject, onClose, dismissible }) => {
  if (!open) return null;
  return (
    <div
      className="fixed inset-x-0 bottom-0 z-[60] px-4 pb-4 md:bottom-4"
      role="region"
      aria-label="Cookie preferences"
      data-testid="cookie-banner"
    >
      <div className="mx-auto max-w-3xl rounded-2xl border border-brand-border bg-white p-5 shadow-2xl sm:p-6">
        <div className="flex items-start gap-4">
          <span className="grid h-11 w-11 flex-shrink-0 place-items-center rounded-xl bg-brand-teal/10 text-brand-teal">
            <Cookie className="h-6 w-6" aria-hidden="true" />
          </span>
          <div className="flex-1">
            <div className="flex items-start justify-between gap-3">
              <h2 className="font-heading text-lg font-bold text-brand-navy">Your cookie preferences</h2>
              {dismissible && (
                <button
                  type="button"
                  onClick={onClose}
                  aria-label="Close cookie preferences"
                  className="inline-flex h-8 w-8 items-center justify-center rounded-full text-brand-navy/60 hover:text-brand-navy"
                  data-testid="cookie-close"
                >
                  <X className="h-5 w-5" />
                </button>
              )}
            </div>
            <p className="mt-2 text-sm leading-relaxed text-brand-body">
              We use essential cookies to make this site work. With your consent, we would also
              like to use analytics cookies to understand how the site is used. Analytics will
              not load until you accept. See our{" "}
              <a
                href={businessDetails.privacyPolicyUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="font-semibold text-brand-teal underline"
              >
                privacy notice
              </a>
              .
            </p>
            <div className="mt-4 flex flex-col gap-2 sm:flex-row">
              <button
                type="button"
                onClick={onAccept}
                className="inline-flex min-h-[44px] items-center justify-center rounded-full bg-brand-teal px-5 font-semibold text-white transition-colors hover:bg-brand-tealHover"
                data-testid="cookie-accept"
              >
                Accept analytics cookies
              </button>
              <button
                type="button"
                onClick={onReject}
                className="inline-flex min-h-[44px] items-center justify-center rounded-full border border-brand-navy px-5 font-semibold text-brand-navy transition-colors hover:bg-brand-navy hover:text-white"
                data-testid="cookie-reject"
              >
                Essential only
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
